import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "reactstrap";
import { isEmpty } from "lodash";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import moment from "moment";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import debounce from "lodash/debounce";
import "assets/scss/table.scss";

import Breadcrumbs from "components/Common/Breadcrumb";
import { getSchemeAnalytesList } from "store/results/actions";
import { getResultSubmit } from "store/resultsSubmit/actions";
import { getStatisticsList } from "store/results/actions";
import { updateRoundList } from "store/rounds/actions";
import { saveStatisticsStatus } from "store/results/actions";
import "assets/scss/table.scss";
import axios from "axios";
class Results extends Component {
  constructor(props) {
    super(props);
    this.handleRejectedCountClick = this.handleRejectedCountClick.bind(this);
    this.node = React.createRef();
    this.state = {
      SchemeAnalytesList: [],
      buttonText: "Calculate",
      ResultSubmit: [],
      Statistics: [],
      selectedStatus: {},
      combinedData: [], // Store the combined data here
      // analyte: "",
      // rounds: [],
      conditionModal: false,
      conditionModalTitle: "",
      conditionLabs: [],
      rejectedLabsModal: false,
      rejectedLabsList: [],
      rejectedLabsAnalyteName: "",
      conditionLabsLoading: false,
      isCalculated: false, // Flag to track calculation status
      successMessage: "",
      modal: false, // Modal state for visibility control
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      columnsList: [
        {
          text: "Analyte",
          dataField: "name",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div className="text-start">{analyte.name}</div>
          ),
        },
        {
          text: "N",
          sort: true,
          formatter: (cellContent, analyte) => {
            const roundId = this.props.match.params.id; // get round id from route params
            return (
              <div className="text-start">
                <Link
                  to={`/statistic-participant/${this.props.scheme_id}/${roundId}/${analyte.id}`}
                >
                  {analyte.lab_count}
                </Link>
              </div>
            );
          },
        },
        {
          text: "Sample Condition",
          sort: true,
          formatter: (cellContent, analyte) => {
            const counts = analyte.sample_condition_counts || {};
            const total = Object.values(counts).reduce((sum, c) => sum + c, 0);

            if (total === 0) return <div className="text-start">—</div>;

            const handleClick = () => {
              // ✅ filter from lab_info, exclude "Not Specified"
              const labs = Array.isArray(analyte.lab_info)
                ? analyte.lab_info.filter(
                    (lab) =>
                      lab.sample_condition &&
                      lab.sample_condition !== "Not Specified" &&
                      lab.sample_condition !== "Not Selected" &&
                      lab.sample_condition.trim() !== "",
                  )
                : [];

              this.setState({
                conditionModal: true,
                conditionModalTitle: `Labs for ${analyte.name}`,
                conditionLabs: labs,
              });
            };

            return (
              <div
                className="text-start text-primary cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={handleClick}
              >
                <strong>{total}</strong>
              </div>
            );
          },
        },
        {
          text: "Rejected Count With Sample Condition",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div
              className="text-start"
              style={{
                cursor:
                  analyte.rejected_with_condition > 0 ? "pointer" : "default",
                color:
                  analyte.rejected_with_condition > 0 ? "#dc3545" : "inherit",
                fontWeight:
                  analyte.rejected_with_condition > 0 ? "bold" : "normal",
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (analyte.rejected_with_condition > 0) {
                  this.handleRejectedCountClick(analyte, "condition"); // ✅
                }
              }}
            >
              {analyte.rejected_with_condition || 0}
            </div>
          ),
        },
        {
          text: "Rejected Count of All Participants",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div
              className="text-start"
              style={{
                cursor: analyte.rejected_all > 0 ? "pointer" : "default",
                color: analyte.rejected_all > 0 ? "#dc3545" : "inherit",
                fontWeight: analyte.rejected_all > 0 ? "bold" : "normal",
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (analyte.rejected_all > 0) {
                  this.handleRejectedCountClick(analyte, "all"); // ✅
                }
              }}
            >
              {analyte.rejected_all || 0}
            </div>
          ),
        },
        {
          text: "Mean",
          // dataField: "lab_count",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div className="text-start">{analyte.mean_result}</div>
          ),
        },
        {
          text: "Median",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div className="text-start">{analyte.median_result}</div>
          ),
        },
        {
          text: "Robust Mean",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div className="text-start">{analyte.robust_mean}</div>
          ),
        },
        {
          text: "SD",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div className="text-start">{analyte.std_deviation}</div>
          ),
        },
        {
          text: "Uncertainty",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div className="text-start">{analyte.uncertainty}</div>
          ),
        },
        {
          text: "CV %",
          sort: true,
          formatter: (cellContent, analyte) => (
            <div className="text-start">{analyte.cv_percentage}</div>
          ),
        },
        {
          text: "Select Status",
          dataField: "status",
          formatter: (cell, analyte) => (
            <select
              className="form-select"
              value={analyte.status || ""}
              onChange={(e) =>
                this.handleStatusChange(analyte.id, e.target.value)
              }
            >
              <option value="">Select</option>
              <option value="Rejected">Abrogate</option>
            </select>
          ),
        },
      ],
    };
  }
  combineData = (analytes, results) => {
    return analytes.map((analyte) => {
      const resultEntry = results?.find(
        (result) => result.analyte === analyte.id,
      );

      // ✅ lab_info lives in ResultSubmit, not Statistics
      const resultSubmitEntry = this.props.ResultSubmit?.find(
        (r) => String(r.analyte) === String(analyte.id),
      );

      const labCount = resultEntry?.lab_count || 0;
      const meanResult = resultEntry?.mean_result || 0;
      const medianResult = resultEntry?.median_result || 0;
      const RobustMean = resultEntry?.robust_mean || 0;
      const standarDeviation = resultEntry?.std_deviation || 0;
      const Uncertainty = resultEntry?.uncertainty || 0;
      const CvPercentage = resultEntry?.cv_percentage || 0;
      const rejectedWithCondition =
        resultEntry?.rejected_participants_with_condition || 0;
      const rejectedAll = resultEntry?.rejected_participants_all || 0;
      const acceptedCount = resultEntry?.accepted_count || 0;
      const warningCount = resultEntry?.warning_count || 0;

      const rejectedLabs = resultEntry?.rejected_all_labs || [];
      const rejectedWithConditionLabs =
        resultEntry?.rejected_with_condition_labs || [];

      // ✅ pulled from ResultSubmit, not Statistics
      const labInfo = resultSubmitEntry?.lab_info || [];

      const sampleConditionCounts = this.getConditionCounts(
        this.props.ResultSubmit,
        analyte.id,
      );

      return {
        ...analyte,
        lab_count: labCount,
        mean_result: meanResult,
        median_result: medianResult,
        sample_condition_counts: sampleConditionCounts,
        robust_mean: RobustMean,
        std_deviation: standarDeviation,
        uncertainty: Uncertainty,
        cv_percentage: CvPercentage,
        rejected_labs: rejectedLabs,
        rejected_with_condition_labs: rejectedWithConditionLabs,
        lab_info: labInfo, // ✅ now correctly sourced
        rejected_with_condition: rejectedWithCondition,
        rejected_all: rejectedAll,
        accepted_count: acceptedCount,
        warning_count: warningCount,
        status: analyte.status || "",
      };
    });
  };
  isAllFieldsZero = (data) => {
    // Check if all the relevant fields in the data are equal to 0
    return data.every(
      (item) =>
        item.lab_count === 0 &&
        item.mean_result === 0 &&
        item.median_result === 0 &&
        item.robust_mean === 0 &&
        item.std_deviation === 0 &&
        item.uncertainty === 0 &&
        item.cv_percentage === 0,
    );
  };

  componentDidUpdate(prevProps, prevState) {
    const { SchemeAnalytesList, ResultSubmit, Statistics } = this.props;

    const schemeChanged =
      SchemeAnalytesList !== prevProps.SchemeAnalytesList &&
      !isEmpty(SchemeAnalytesList);
    const resultChanged =
      ResultSubmit !== prevProps.ResultSubmit && !isEmpty(ResultSubmit);
    const statsChanged =
      Statistics !== prevProps.Statistics && !isEmpty(Statistics);

    if (schemeChanged || resultChanged || statsChanged) {
      // ✅ Guard: only rebuild if ALL three are available
      if (
        isEmpty(this.props.SchemeAnalytesList) ||
        isEmpty(this.props.Statistics) ||
        isEmpty(this.props.ResultSubmit)
      ) {
        return; // wait until all data is loaded
      }

      const combinedData = this.combineData(
        this.props.SchemeAnalytesList,
        this.props.Statistics,
      );
      const isZero = this.isAllFieldsZero(combinedData);
      this.setState({
        SchemeAnalytesList: SchemeAnalytesList,
        ResultSubmitList: ResultSubmit,
        StatisticsList: Statistics,
        combinedData,
        buttonText: isZero ? "Calculate" : "Recalculate",
        isCalculated: prevState.isCalculated,
      });
    }
  }

  componentDidMount() {
    const { onGetSchemeAnalyte, onGetStatisticsList, onGetResultSubmit } =
      this.props;
    const id = this.props.match.params.id;

    Promise.all([
      onGetSchemeAnalyte(id),
      onGetStatisticsList(id),
      onGetResultSubmit(id),
    ])
      .then(() => {
        const { SchemeAnalytesList, Statistics } = this.props;
        const combinedData = this.combineData(SchemeAnalytesList, Statistics); // ✅ Statistics always
        const isZero = this.isAllFieldsZero(combinedData);
        this.setState({
          combinedData,
          buttonText: isZero ? "Calculate" : "Recalculate",
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }

  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  handleCalculate = async () => {
    const { onGetSchemeAnalyte, onGetResultSubmit } = this.props;
    const id = this.props.match.params.id;

    // 1️⃣ Fetch fresh data
    await onGetSchemeAnalyte(id);
    await onGetResultSubmit(id);

    // 2️⃣ Combine data for UI
    const combinedData = this.combineData(
      this.props.SchemeAnalytesList,
      this.props.ResultSubmit,
    );

    this.setState({
      combinedData,
      isCalculated: true, // ✅ enables Save button
      buttonText: "Recalculate",
    });

    // 3️⃣ UI feedback only
    this.displaySuccessMessage("Statistics calculated successfully!");
  };

  handleStatusChange = (analyteId, value) => {
    this.setState((prevState) => ({
      combinedData: prevState.combinedData.map((item) =>
        item.id === analyteId ? { ...item, status: value } : item,
      ),
    }));
  };

  handleReport = (round) => {
    if (round && round.id) {
      // Update the round's status to "report available"
      const updatedRound = {
        ...round,
        status: "Report Available",
        added_by: this.state.user_id,
      };

      // Dispatch the update action to save the new status
      this.props.onUpdateRound(round.id, updatedRound);
      this.displaySuccessMessage("Round Status is changed to Report Available");
    }
  };
  // Function to display the success message
  displaySuccessMessage = (message) => {
    this.setState({ successMessage: message, modal: true }); // Open the modal

    setTimeout(() => {
      this.setState({ successMessage: "", modal: false }); // Close the modal after 2 seconds
    }, 3000);
  };
  handleSave = async () => {
    const roundId = this.props.match.params.id;

    const payload = this.state.combinedData
      .filter((item) => item.status)
      .map((item) => ({
        round: roundId,
        analyte: item.id,
        status: item.status,
        created_by: this.state.user_id,
      }));

    if (!payload.length) {
      this.displaySuccessMessage("Please select at least one status");
      return;
    }

    try {
      await this.props.saveStatisticsStatusRequest(payload); // Dispatch redux action
      this.displaySuccessMessage("Statistics status saved successfully!");
    } catch (error) {
      console.error(error);
      this.displaySuccessMessage("Failed to save status!");
    }
  };
  handleConditionClick = (condition) => {
    const labNames = this.props.sample_condition_labs?.[condition] || [];

    const labs = labNames.map((name) => ({
      lab_id: name, // use name as key since backend only sends strings
      lab_name: name,
      sample_condition: condition,
    }));

    this.setState({
      conditionModal: true,
      conditionModalTitle: condition,
      conditionLabs: labs,
    });
  };
  getConditionCounts = (resultSubmitList, analyteId) => {
    const counts = {
      Clotted: 0,
      Hemolyzed: 0,
      Icteric: 0,
      Lipemic: 0,
    };

    if (!Array.isArray(resultSubmitList) || !analyteId) return counts;

    // Find the result entry for this analyte
    const resultEntry = resultSubmitList.find(
      (r) => String(r.analyte) === String(analyteId),
    );

    if (!resultEntry || !Array.isArray(resultEntry.lab_info)) return counts;

    // Loop through lab_info array where sample_condition lives
    resultEntry.lab_info.forEach((lab) => {
      const cond = (lab.sample_condition || "").trim();
      if (!cond || cond === "null" || cond === "-" || cond === "Not Selected")
        return;

      if (counts[cond] !== undefined) {
        counts[cond]++;
      }
    });

    return counts;
  };
  handleRejectedCountClick = (analyte, type) => {
    // type = "all" | "condition"
    const rejectedLabs =
      type === "condition"
        ? analyte.rejected_with_condition_labs || []
        : analyte.rejected_labs || [];

    this.setState({
      rejectedLabsModal: true,
      rejectedLabsList: rejectedLabs,
      rejectedLabsAnalyteName:
        analyte.name +
        (type === "condition" ? " — with sample condition" : " — all rejected"),
    });
  };
  render() {
    // };
    const {
      closing_date,
      rounds,
      scheme_name,
      scheme_type,
      cycle_no,
      round_issuedate,
      round_status,
      sample_condition_counts,
    } = this.props;

    const { combinedData } = this.state; // Use the combined data
    const pageOptions = {
      sizePerPage: 50,
      totalSize: combinedData.length, // Adjust totalSize for combined data
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "analyte_name",
        order: "desc",
      },
    ];
    const { issue_date } = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Unapproved Participant | NEQAS</title>
          </MetaTags>
          <Container fluid>
            <Modal
              isOpen={this.state.rejectedLabsModal}
              toggle={() => this.setState({ rejectedLabsModal: false })}
            >
              <ModalHeader
                toggle={() => this.setState({ rejectedLabsModal: false })}
              >
                Rejected Labs — {this.state.rejectedLabsAnalyteName}
              </ModalHeader>
              <ModalBody>
                {this.state.rejectedLabsList.length > 0 ? (
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>#</th>
                        <th style={{ textAlign: "center" }}>Lab Name</th>
                        <th style={{ textAlign: "center" }}>Result</th>
                        <th style={{ textAlign: "center" }}>Z-Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rejectedLabsList.map((lab, i) => (
                        <tr key={lab.lab_id}>
                          <td style={{ textAlign: "left" }}>{i + 1}</td>
                          <td style={{ textAlign: "left" }}>{lab.lab_name}</td>
                          <td style={{ textAlign: "left" }}>{lab.result}</td>
                          <td
                            style={{
                              textAlign: "left",
                              color: "#dc3545",
                              fontWeight: "bold",
                            }}
                          >
                            {lab.z_score}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-muted text-center py-3">
                    No rejected labs found.
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.setState({ rejectedLabsModal: false })}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.conditionModal}
              toggle={() => this.setState({ conditionModal: false })}
            >
              <ModalHeader
                toggle={() => this.setState({ conditionModal: false })}
              >
                {this.state.conditionModalTitle}
              </ModalHeader>
              <ModalBody>
                {this.state.conditionLabs.length > 0 ? (
                  <div>
                    {["Clotted", "Hemolyzed", "Icteric", "Lipemic"].map(
                      (cond) => {
                        const labsForCond = this.state.conditionLabs.filter(
                          (lab) => lab.sample_condition === cond,
                        );
                        if (labsForCond.length === 0) return null;
                        return (
                          <div key={cond} className="mb-2">
                            <strong>{cond}:</strong>
                            <ul>
                              {labsForCond.map((lab) => (
                                <li key={lab.lab_id}>{lab.lab_name}</li>
                              ))}
                            </ul>
                          </div>
                        );
                      },
                    )}
                  </div>
                ) : (
                  <p>No labs submitted with a sample condition.</p>
                )}
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.setState({ conditionModal: false })}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
            <Row
              className="mb-3 justify-content-start"
              style={{ marginLeft: "120px" }}
            >
              <Col>
                <Row className="mb-3" style={{ marginLeft: "80px" }}>
                  {/* First Button: Add Values */}
                  <Col md={2}>
                    <Button
                      color="primary"
                      onClick={() => this.handleCalculate()}
                      className="w-100"
                    >
                      {this.state.buttonText}
                    </Button>
                  </Col>

                  {/* Spacer Column */}
                  <Col md={2}>
                    <Button
                      color="success"
                      onClick={this.handleSave}
                      className="w-100"
                      disabled={!this.state.isCalculated}
                    >
                      Save
                    </Button>
                  </Col>
                  <Col md={2}></Col>
                  <Col md={2}></Col>

                  {/* Second Button: Calculate */}

                  {scheme_type === "Qualitative" && (
                    <Col md={2}>
                      <Link
                        to={`/${this.state.organization_name}/slectValues/${this.props.match.params.id}`}
                      >
                        <Button color="primary" className="w-100">
                          Assign Values
                        </Button>
                      </Link>
                    </Col>
                  )}

                  <Col md={2}></Col>
                </Row>

                {/* Show the "Report" button only when the button text is "Recalculate" */}
                {/* {this.state.buttonText === "Recalculate" && (
                  <Button
                    color="secondary"
                    onClick={() => this.handleReport(issue_date)}
                    className=""
                  >
                    Report
                  </Button>
                )} */}
              </Col>
            </Row>

            {/* Modal for displaying success message */}
            <Modal
              isOpen={this.state.modal}
              toggle={() => this.setState({ modal: !this.state.modal })}
            >
              <ModalHeader
                toggle={() => this.setState({ modal: !this.state.modal })}
              >
                Success
              </ModalHeader>
              <ModalBody>{this.state.successMessage}</ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  onClick={() => this.setState({ modal: false })}
                >
                  OK
                </Button>
              </ModalFooter>
            </Modal>

            <div className="container">
              <Row className="mb-4">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Round:</span>
                    <span>
                      <strong>{rounds ? rounds : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Name:</span>
                    <span>
                      <strong>{scheme_name ? scheme_name : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Type:</span>
                    <span>
                      <strong>{scheme_type ? scheme_type : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Cycle No:</span>
                    <span>
                      <strong>{cycle_no ? cycle_no : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Closing Date:</span>
                    <span>
                      <strong>
                        {closing_date
                          ? moment(closing_date).format("DD-MMM-YYYY, h:mm A")
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Issued Date:</span>
                    <span>
                      <strong>
                        {round_issuedate
                          ? moment(round_issuedate).format(
                              "DD-MMM-YYYY, h:mm A",
                            )
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Status:</span>
                    <span>
                      <strong>{round_status ? round_status : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            {sample_condition_counts &&
              Object.keys(sample_condition_counts).length > 0 && (
                <Row className="mb-3" style={{ marginLeft: "125px" }}>
                  <Col md={12}>
                    <div className="d-flex flex-wrap align-items-center gap-3">
                      <span
                        className="text-muted fw-semibold"
                        style={{ fontSize: "13px", whiteSpace: "nowrap" }}
                      >
                        Sample Condition:
                      </span>

                      {Object.entries(sample_condition_counts)
                        .filter(
                          ([condition, count]) =>
                            condition && // remove undefined/null keys
                            // condition !== "Not Selected" &&
                            // condition !== "null" &&
                            // condition !== "undefined" &&
                            condition.trim() !== "" &&
                            count > 0, // optional: hide zero counts
                        )
                        .map(([condition, count]) => (
                          <div
                            key={condition}
                            className="border rounded px-3 py-1 d-flex align-items-center gap-2"
                          >
                            <span
                              className="text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              {condition}
                            </span>
                            <strong
                              style={{
                                fontSize: "15px",
                                cursor: "pointer",
                                color: "#0d6efd",
                              }}
                              onClick={() =>
                                this.handleConditionClick(condition)
                              }
                              title="Click to view labs"
                            >
                              {count}
                            </strong>
                          </div>
                        ))}
                    </div>
                  </Col>
                </Row>
              )}

            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.columnsList}
                      data={combinedData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.columnsList}
                          data={combinedData}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <div className="table-responsive">
                                <BootstrapTable
                                  id="printable-table"
                                  keyField="id"
                                  ref={this.node}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  classes={"table table-bordered table-hover"}
                                  {...toolkitprops.baseProps}
                                  {...paginationTableProps}
                                />
                                <div className="float-end">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                    onPageChange={this.onPaginationPageChange}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Results.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,

  SchemeAnalytesList: PropTypes.array,
  ResultSubmit: PropTypes.array,
  Statistics: PropTypes.array,
  rounds: PropTypes.string,
  issue_date: PropTypes.object,
  scheme_name: PropTypes.string,
  scheme_type: PropTypes.string,
  rounds: PropTypes.string,
  closing_date: PropTypes.string,
  round_issuedate: PropTypes.string,
  round_status: PropTypes.string,
  cycle_no: PropTypes.string,

  // closing_date: PropTypes.string,
  onGetSchemeAnalyte: PropTypes.func,
  onGetResultSubmit: PropTypes.func,
  onGetStatisticsList: PropTypes.func,
  saveStatisticsStatusRequest: PropTypes.func,
  onUpdateRound: PropTypes.func,
  sample_condition_counts: PropTypes.object,
  sample_condition_labs: PropTypes.object,
  scheme_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const mapStateToProps = ({ SchemeAnalytesList, ResultSubmit }) => ({
  SchemeAnalytesList: SchemeAnalytesList.SchemeAnalytesList,
  ResultSubmit: ResultSubmit.ResultSubmit,
  rounds: SchemeAnalytesList.rounds,
  rounds_instance: SchemeAnalytesList.rounds_instance,
  closing_date: SchemeAnalytesList.closing_date,
  Statistics: SchemeAnalytesList.Statistics,
  scheme_name: SchemeAnalytesList.schemeName,
  scheme_type: SchemeAnalytesList.schemeType,
  // rounds: SchemeAnalytesList.rounds,
  // closing_date: SchemeAnalytesList.closing_date,
  round_issuedate: SchemeAnalytesList.issue_date,
  round_status: SchemeAnalytesList.round_status,
  cycle_no: SchemeAnalytesList.cycle_no,
  sample_condition_counts: SchemeAnalytesList.sampleConditionCounts, // must match reducer key
  sample_condition_labs: SchemeAnalytesList.sampleConditionLabs,
  scheme_id: SchemeAnalytesList.scheme_id,
});

const mapDispatchToProps = (dispatch) => ({
  onGetSchemeAnalyte: (id) => dispatch(getSchemeAnalytesList(id)),
  onGetResultSubmit: (id) => dispatch(getResultSubmit(id)),
  onGetStatisticsList: (id) => dispatch(getStatisticsList(id)),
  onUpdateRound: (id, round) => dispatch(updateRoundList({ id, ...round })),
  saveStatisticsStatusRequest: (payload) =>
    dispatch(saveStatisticsStatus(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Results));
